<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin, BTable,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import axios from '@axios';
import { required, email } from '@validations';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { ref } from '@vue/composition-api';
import useListContato from '@/views/cadastros/cliente//cliente/list//useListContato';
import { avatarText } from '@core/utils/filter';
import SLSClienteContatoService from '@/services/Cadastros/Cliente/SLSClienteContato.service';
import ModalConfirmation from '@/components/ModalConfirmation.vue';

export default {
  components: {
    ModalConfirmation,
    BTable,
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        clientecontatoseq: '',
        estabelecimentoid: '',
      }),
      require: true,
    },

  },
  data() {
    return {
      dataFromApi: null,
      dataFromUfId: null,
      deletedContato: null,
      isDeleteModal: false,
    };
  },
  computed: {
    dataForm: {
      get() {
        return this.dataClienteContato;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    openModalDeleteContato(data) {
      this.deletedContato = data;
      this.isDeleteModal = true;
    },
    resetFormData() {
      this.deletedContato = null;
      this.isDeleteModal = false;
    },
    handleRemover(data) {
      this.removerData(data);
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Contato deletada com sucesso',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      this.isDeleteModal = false;
    },
    async validateForm() {
      this.$emit('ok', this.dataForm);
      this.$bvModal.hide(this.idModal);
    },
  },
  setup(props) {
    const sLSClienteContatoService = new SLSClienteContatoService();
    const currentTab = ref(0);
    const spanderAll = ref(false);
    const formularioAtt = ref(false);
    const formularioAdd = ref(false);
    const dataClienteContato = ref({
      clienteid: props.value.clienteid,
      clientecontatoseq: '',
      clienteiderp: props.value.clienteiderp,
      clientecontatonome: '',
      clientecontatoemail: '',
      clientarea: '',
      clientecontatotelefone: '',
      clientecontatoramal: '',
      clientecontatocelular: '',
      clientecontatoprincipal: '',
      clientecontatoobservacoes: '',
    });
    const formularioVisible = (status, tipo, item) => {
      if (status === 1) {
        if (tipo === 'att') {
          dataClienteContato.value = item;
          formularioAtt.value = true;
        } else {
          dataClienteContato.value.clientecontatoseq = '';
          dataClienteContato.value.clientecontatonome = '';
          dataClienteContato.value.clientecontatoemail = '';
          dataClienteContato.value.clientarea = '',
          dataClienteContato.value.clientecontatotelefone = '',
          dataClienteContato.value.clientecontatoramal = '',
          dataClienteContato.value.clientecontatocelular = '',
          dataClienteContato.value.clientecontatoprincipal = '',
          dataClienteContato.value.clientecontatoobservacoes = '',
          formularioAdd.value = true;
        }
      } else {
        formularioAtt.value = false;
        formularioAdd.value = false;
      }
    };
    const fetchClienteContato = (ctx, callback) => {
      const { clienteid } = props.value;
      const queries = {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        fullObject: true,
        clienteid,
      };

      sLSClienteContatoService.findContatoCliente(queries)
        .then((response) => {
          const { data, total } = response;
          callback(data);
          perPage.value = response.perPage;
          currentPage.value = response.page;
          totalClienteContato.value = total;
        })
        .catch((error) => {
          // console.log(error)
          // toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: 'Error fetching users list',
          //     icon: 'AlertTriangleIcon',
          //     variant: 'danger',
          //   },
          // });
        });
    };

    const {
      perPage,
      currentPage,
      totalClienteContato,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      tableColumns,
      refClienteContatoListTable,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      Updated,
      create,
      removerData,
    } = useListContato();

    return {
      // Filter
      avatarText,
      spanderAll,
      currentTab,
      dataClienteContato,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      perPage,
      currentPage,
      totalClienteContato,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      fetchClienteContato,
      formularioVisible,
      tableColumns,
      formularioAdd,
      formularioAtt,
      refClienteContatoListTable,
      Updated,
      create,
      removerData,
    };
  },
};
</script>

<template>
  <validation-observer ref="refFormData">
    <div  v-if="formularioAtt">
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="secondary"
          @click="formularioVisible(0)"

      >
        Voltar
      </b-button>
      <b-form class="mt-1" @submit.prevent>
        <b-row>
          <b-col
              cols="6"
              class="mb-0"
          >
            <b-form-group
                label="Sequencia"
                label-for="clientecontatoseq"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clientecontatoseq"
                    id="clientecontatoseq"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Digite o id"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Tipo Contato"
                label-for="tipocontatoid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Tipo Contato"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.tipocontatoid"
                    id="tipocontatoid"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Digite o id"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Cep"
                label-for="clientecontatoemail"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clientecontatoemail"
                    id="clientecontatoemail"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Digite o id"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Contato"
                label-for="clientecontato"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Contato"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clientecontato"
                    id="clientecontato"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Contato"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Telefone"
                label-for="clientecontatotelefone"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Telefone"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clientecontatotelefone"
                    id="clientecontatotelefone"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Telefone"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Ramal"
                label-for="clientecontatoramal"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Ramal"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clientecontatoramal"
                    id="clientecontatoramal"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromApi"
                    placeholder="Ramal"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Celular"
                label-for="clientecontatocelular"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Celular"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clientecontatocelular"
                    id="clientecontatocelular"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromApi"
                    placeholder="Uf"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Contato Principal"
                label-for="clientecontatoprincipal"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Contato Principal"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clientecontatoprincipal"
                    id="clientecontatoprincipal"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromApi"
                    placeholder="Contato Principal"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Inscr. Estadual"
                label-for="clientecontatoobservacoes"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Inscr. Estadual"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.clientecontatoobservacoes"
                    id="clientecontatoobservacoes"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromApi"
                    placeholder="Contato Principal"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="success"
          @click="create(dataForm)"
      >
        Salvar Alterações
      </b-button>
    </div>
    <div  v-else-if="formularioAdd">
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="secondary"
          @click="formularioVisible(0)"
      >
        Voltar
      </b-button>
      <b-form class="mt-1" @submit.prevent >
        <b-row>
          <b-col
              cols="6"
              class="mb-0"
          >
            <b-form-group
                label="Seq."
                label-for="clientecontatoseq"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clientecontatoseq"
                    id="clientecontatoseq"
                    :state="errors.length > 0 ? false : null"
                    placeholder=""
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-0"
          >
            <b-form-group
                label="Nome"
                label-for="clientecontatonome"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clientecontatonome"
                    id="clientecontatonome"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Nome"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Email"
                label-for="clientecontatoemail"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clientecontatoemail"
                    id="clientecontatoemail"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Email"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Area"
                label-for="clientecontato"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Area"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clientarea"
                    id="clientarea"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Area"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Telefone"
                label-for="clientecontatotelefone"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Telefone"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clientecontatotelefone"
                    id="clientecontatotelefone"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Telefone"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Ramal"
                label-for="clientecontatoramal"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Ramal"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.clientecontatoramal"
                    id="clientecontatoramal"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromApi"
                    placeholder="Uf"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Celular"
                label-for="clientecontatocelular"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Celular"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.clientecontatocelular"
                    id="clientecontatocelular"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromApi"
                    placeholder="Uf"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Contato Principal"
                label-for="clientecontatoprincipal"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Contato Principal"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.clientecontatoprincipal"
                    id="clientecontatoprincipal"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromApi"
                    placeholder="Contato Principal"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Observacoes"
                label-for="clientecontatoobservacoes"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Observacoes"
                  rules="required"
              >
                <b-form-textarea
                    v-model="dataForm.clientecontatoobservacoes"
                    id="clientecontatoobservacoes"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Observacoes"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="success"
          @click="create(dataForm)"
      >
        Salvar Alterações
      </b-button>
    </div>
    <div  v-else>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrar</label>
            <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
            />
            <label>entradas</label>
          </b-col>

          <b-col
              cols="12"
              md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Pesquisar..."
              />
              <b-button
                  variant="primary"
                  @click="formularioVisible(1,'add')"
              >
                <div class="d-flex" style="gap: 5px">
                  <iconfy icon="mdi:plus"/>
                  <span class="">Criar</span>
                </div>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
      <b-table
          ref="refClienteContatoListTable"
          class="position-relative"
          :items="fetchClienteContato"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="Nenhum registro encontrado"
      >
        <template #cell(actions)="data">
          <div>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="gradient-primary"
                class="btn-icon mr-1"
                @click="formularioVisible(1, 'att',data.item)"
            >
              <feather-icon icon="EyeIcon"/>
            </b-button>

            <b-button
                variant="gradient-danger"
                class="btn-icon"
                @click="openModalDeleteContato(data.item)"
            >
              <feather-icon icon="TrashIcon"/>
            </b-button>
          </div>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
                      <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{
                          dataMeta.of
                        }} entries</span>
          </b-col>

          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
                v-model="currentPage"
                :total-rows="totalClienteContato"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>

    </div>
    <modal-confirmation
        v-model="isDeleteModal"
        id-modal="modal-delete-contato"
        title="Deletar Contato"
        btn-cancel-label="Cancelar"
        btn-ok-label="Sim, deletar"
        @ok="handleRemover(deletedContato)"
        @cancel="resetFormData()"
    >
      <template #message>
        <div>
          <p>Tem certeza que deseja deletar essa Endereço?</p>
        </div>
      </template>
    </modal-confirmation>

  </validation-observer>

</template>
